import { render, staticRenderFns } from "./ClientContacts.vue?vue&type=template&id=fa6197ce&scoped=true"
import script from "./ClientContacts.vue?vue&type=script&lang=js"
export * from "./ClientContacts.vue?vue&type=script&lang=js"
import style0 from "./ClientContacts.vue?vue&type=style&index=0&id=fa6197ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6197ce",
  null
  
)

export default component.exports